module.exports = __webpack_public_path__ + "img/wechat-launch-2014.91603f84.jpg";